// extracted by mini-css-extract-plugin
module.exports =  {"amount":"wAgD8bB5t59EhQ6MgulZ"};